import { render, staticRenderFns } from "./DeviceDetail.vue?vue&type=template&id=5efe184c&"
import script from "./DeviceDetail.vue?vue&type=script&lang=ts&"
export * from "./DeviceDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports